import { gql } from '@apollo/client';

export const GET_CONTRACT_INSTANCE = gql`
  query getContractInstance($input: GetContractInstanceInput!) {
    getContractInstance(input: $input) {
      contractId
      signedStatus
      signerUrl
      dateCreated
      dateModified
      customerId
      productInstanceId
      contractState {
        state
        reason
      }
    }
  }
`;
